import { all, takeEvery } from 'redux-saga/effects';
import { updateDocumentsWithCryptIdWorker, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { watchNavigationRequested } from './navigationRequested';
import { watchLoadActionRequested } from './loadAvSaga';
import { watchSpeichernRequested } from './speicherdatenSaga';
import { watchDoRequest } from './doRequestSaga/doRequestSaga';
import { watchFeatureTogglesOnceForEinstiegSaga } from './einstiegRequested';
import { watchMasterProduktSaga } from './masterProduktSaga';
import { isTarifierungActive } from './isTarifierungActiveSaga';
import { watchShowModalRequestedTrigger } from './showModalSaga';
import { watchFeatureToggleRequestedEvent } from './featureToggleRequestedSaga';
import { watchAppHasBeenUpdated } from './appHasBeenUpdatedSaga';
import { adressvorschlagSaga } from './adressvorschlagSaga';
import { watchAmisCrmImmobilieRequested } from './amisCrmImmobilieRequested';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStateSnapshotForAllApps } from './stateSnapshotForAllAppsSaga';
import { watchTarifierungSagas } from './tarifierung';
import { watchLogError } from './logErrorSaga';
import { adressvalidierungSaga } from './adressvalidierungSaga';
import { sessionExpiresSaga } from './sessionExpiredSaga';
import { watchAppConfigRequested } from './appConfigRequested';
import { watchAuthenticationRequested } from './authenticationRequestedSaga';
import { watchLoadVorvertraegeSaga } from './loadVorvertraegeSaga';
import { watchTierrassenListRequest } from './tierrassenListeSaga';
import { watchInitializeLogger } from './initializeLogger';
import { watchStoreManagementSaga } from './storeManagementSaga';
import { watchDoQuoteDBRequest } from './doQuoteDBRequestSaga';
import { watchVermittlerNummerRequests } from './provideVermittlernummerSaga';
import { watchUpdateZahlungsweise } from './updateZahlungsweiseSaga';
import { watchUpdateAssekuranztarif } from './updateAssekuranztarifSaga';
import { prometheusCounterSaga } from './prometheusCounterSaga';
import { watchRegexpsRequestedEvent } from './regexpsRequestedSaga';
import { watchAmisCrmPersonenGruppeRequested } from './amisCrmPersonenGruppeRequested';
import { watchSettingsRequestedEvent } from './settingsRequestedSaga';
import { vnAddressInvalidSaga } from './vnAddressInvalidSaga';

function* watchUpdateDocumentsWithCryptIdShop() {
  yield takeEvery(
    GlobalActions.UPDATE_DOCUMENTS_WITH_CRYPTID,
    safeSaga(updateDocumentsWithCryptIdWorker, App.SHOP),
  );
}

export function* rootSaga() {
  yield all([
    watchInitializeLogger(),
    watchAppConfigRequested(),
    watchNavigationRequested(),
    watchFeatureTogglesOnceForEinstiegSaga(),
    watchStoreManagementSaga(),
    watchLoadActionRequested(),
    watchLoadVorvertraegeSaga(),
    watchAuthenticationRequested(),
    watchSpeichernRequested(),
    watchDoRequest(),
    watchMasterProduktSaga(),
    isTarifierungActive(),
    watchShowModalRequestedTrigger(),
    watchFeatureToggleRequestedEvent(),
    watchAppHasBeenUpdated(),
    adressvorschlagSaga(),
    adressvalidierungSaga(),
    watchDoQuoteDBRequest(),
    watchAmisCrmImmobilieRequested(),
    watchAmisCrmPersonenGruppeRequested(),
    watchStateSnapshot(),
    watchStateSnapshotForAllApps(),
    watchLogError(),
    sessionExpiresSaga(),
    watchTierrassenListRequest(),
    watchUpdateZahlungsweise(),
    watchUpdateAssekuranztarif(),
    watchVermittlerNummerRequests(),
    prometheusCounterSaga(),
    watchRegexpsRequestedEvent(),
    watchSettingsRequestedEvent(),
    vnAddressInvalidSaga(),
    watchUpdateDocumentsWithCryptIdShop(),
    ...watchTarifierungSagas(),
  ]);
}
